import React from 'react';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';

import DA from '../../store/ReduxAccess';

import version from '../../version';

const styles = (theme) => ({
  root: {
    backgroundColor: 'white',
    color: 'black',
    zIndex: 2,
    textAlign: 'center',
    margin: 'auto',
    width: '720px',
    height: '400px',
  },
  content: {
    paddingLeft: '200px',
    textAlign: 'left',
  },
  version: {
    fontSize: '40%',
    float: 'right',
  },
});

class VisitorHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: undefined,
      goStraightToLogin: true,
    };
  }

  render() {
    if (this.state.goStraightToLogin) {
      return <Redirect to="login" />;
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    if (DA.userWasLoggedOutDueToIdleTimeout()) {
      return <Redirect to="login" />;
    }

    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <h4>This is the default page for a non-logged-in visitor</h4>
        <div className={classes.content}>
          It should
          <ul>
            <li>display a nice informative slide show</li>
            <li>contain a link to allow the visitor to log in</li>
            <li>contain "Contact Us" information</li>
          </ul>
        </div>
        <div className={classes.version}>{version}</div>
      </div>
    );
  }
}

export default withStyles(styles)(VisitorHome);
